
const ImageCard = ({imageSrc, bgColor, source}) => {
  const styleClass =
  source === "demo"
    ? "h-[290px] w-[86%]"
    : source === "integration" ? "h-[300px] w-[86%]" : "h-[80%] w-[86%]";
    const wrapperStyleClass = source === "integration" ? "h-[300px] md:h-[450px]" : "h-[350px] md:h-[500px]"
  return (
    <div className="w-full">
      <div className={`w-full ${wrapperStyleClass} rounded-[10px] flex items-center justify-center`}       
      style={{ backgroundColor: bgColor }}
      >
        <div className={`${styleClass} rounded-[10px] overflow-hidden`} >
          <img
            src={imageSrc}
            alt="Eveness product description"
            className="w-full h-full object-contain"
            loading="lazy"
          />
        </div>{" "}
      </div>
    </div>
  );
};

export default ImageCard;
